import React, { useState, useEffect } from "react";
import Header from "@img/headerPeluang.png";
import FloatingMenu from "../components/FloatingMenu";

const cardClasses =
  "bg-white p-4 rounded-lg shadow-md flex items-start cursor-pointer";

const JobCard = ({ logo, title, location, about, category, onClick }) => {
  return (
    <div className={cardClasses} onClick={onClick}>
      <img
        src={`${process.env.REACT_APP_API_URL}/${logo}`}
        alt="Company Logo"
        className="w-20 max-h-20 mr-4 object-cover rounded-full"
      />
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-zinc-800">{location}</p>
        <div className="flex gap-x-4">
          <div className="mt-4 bg-blue-200 px-3 py-2 rounded-md">
            <p className="text-[#1c75ac]">{about}</p>
          </div>
          <div className="mt-4 bg-green-200 px-3 py-2 rounded-md">
            <p className="text-green-500">{category}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const JobList = ({ onJobClick }) => {
  const [datas, setData] = useState([]);

  useEffect(() => {
    fetchDataPeluangUsaha();
  }, []);

  const fetchDataPeluangUsaha = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/business-opportunities"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data peluang usaha");
      }
      const data = await response.json();
      const PelUsData = data.data;
      PelUsData.sort((a, b) => a.id - b.id);
      setData(PelUsData);
    } catch (error) {
      setData([]);
    }
  };

  return (
    <div>
      {datas.map((data) => (
        <div className="mt-0" key={data.id}>
          <div className="space-y-4 mt-5">
            <JobCard
              logo={data.image}
              title={data.title}
              location={data.location}
              about={data.about}
              category={data.category}
              onClick={() => onJobClick(data.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const PeluangUsaha = () => {
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [jobDetails, setJobDetails] = useState(null);

  useEffect(() => {
    if (selectedJobId !== null) {
      fetchJobDetails(selectedJobId);
    }
  }, [selectedJobId]);

  const fetchJobDetails = async (id) => {
    try {
      const response = await fetch(
        `https://cms.okoce.net/api/admin/business-opportunities/${id}`
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil detail peluang usaha");
      }
      const data = await response.json();
      setJobDetails(data.data);
    } catch (error) {
      setJobDetails(null);
    }
  };

  const handleJobClick = (id) => {
    setSelectedJobId(id);
  };

  return (
    <>
      <section
        className="mt-[4em] bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${Header})`,
          width: `100%`,
          height: `100%`,
          backgroundSize: `cover`,
        }}
      >
        <div className="px-4 mx-auto max-w-screen-xl text-center py-24 lg:py-56">
          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
            Yuk, Mulai Gabung dan Dapatkan Hasil Tambahan dengan daftar
          </h1>
          <p className="mb-8 text-lg font-normal text-gray-300 lg:text-xl sm:px-16 lg:px-48">
            Fondasi kami, idemu, bersama-sama kita maju dan berkembang untuk
            menciptakan masa depan bersama. 
          </p>
        </div>
      </section>

      <div className="w-full justify-around md:flex-row p-4 bg-gray-100 mobile:grid  mobile:grid-cols-1 mobile:grid-flow-row lg:flex">
        <div className="mobile:max-w-[30rem] mobile:text-sm lg:w-[29rem] lg:mt-5">
          <JobList onJobClick={handleJobClick} />
        </div>
        <div className="bg-white mt-10 rounded-xl flex items-center justify-center mobile:max-w-96 lg:min-w-[60%] lg:h-auto">
          {jobDetails ? (
            <div className="w-full h-full text-zinc-400">
              <div className="mobile:ml-0 mobile:px-4 lg:mt-10 lg:ml-2 lg:pr-16 lg:pl-14">
                <img
                  src={`${process.env.REACT_APP_API_URL}/${jobDetails.image}`}
                  alt={jobDetails.image}
                  className="w-full rounded-2xl max-h-56 sm:max-h-72 md:h-80 lg:h-96 xl:h-[500px] mt-8"
                />

                <h3 className="text-3xl mt-16 ml-1 font-bold text-center text-black mb-6">
                  {jobDetails.title}
                </h3>
                <p className="text-lg mt-2 ml-1 font-normal text-black">
                  <span className="font-bold">Lokasi : </span>
                  {jobDetails.location}
                </p>
                <p className="text-lg mt-1 ml-1 font-normal text-black">
                  <span className="font-bold">Kategori Usaha : </span>
                  {jobDetails.category}
                </p>
                <p className="text-lg mt-1 ml-1 font-normal text-black mb-4">
                  <span className="font-bold">Sistem Kerja : </span>
                  {jobDetails.about}
                </p>
                <div className="w-full mt-10 mr-32 mb-10">
                  <div
                    className="text-lg mt-3 ml-1 font-normal text-black"
                    dangerouslySetInnerHTML={{ __html: jobDetails.description }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <p className="text-zinc-400">
              Silakan pilih peluang usaha di sebelah kiri untuk melihat
              detailnya
            </p>
          )}
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default PeluangUsaha;
